import { SplashScreenService } from './shared/splashScreen/splash-screen.service';
import {
  Router,
  NavigationStart,
  ActivatedRoute,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  NavigationCancel,
  NavigationEnd
} from '@angular/router';
import { Component, ChangeDetectorRef, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TitleService } from './shared/title-service/title.service';


import { environment } from 'src/environments/environment';
import { UserService } from './services/userService/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'apptp-frontend';
  @ViewChild('splashScreen', { read: ElementRef })
  splashScreen: ElementRef;
  splashScreenImage: string;

  constructor(
    private router: Router,
    private sharedService: UserService,
    private activatedRoute: ActivatedRoute,
    private _ref: ChangeDetectorRef,
    private splashScreenService: SplashScreenService,
    private _titleService: TitleService,

  ) {
    // page progress bar percentage
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        // set page progress bar loading to end on NavigationEnd event router
        window.scrollTo(0, 0);
        this._ref.markForCheck();
      }
      if (event instanceof NavigationEnd) {
        if((<any>window).ga){
          (<any>window).ga('create', environment.ga_token, 'auto');
          (<any>window).ga('set', 'page', event.urlAfterRedirects);
          (<any>window).ga('send', 'pageview');
        }
      }
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this._titleService.updateTitle();
  }

  ngAfterViewInit(): void {
    if (this.splashScreen) {
      this.splashScreenService.init(this.splashScreen.nativeElement);
    }
  }

}
